<mat-card appearance="outlined" *appRoles="['Audiencias.Listar']">
  <mat-card-header>
    <div class="header-nombre-nuevo">
      <h2>Audiencias</h2>
      <app-button-new (click)="openDialog({ accion: accionesDialog.Agregar, entidad: {idExpediente} })"></app-button-new>
    </div>
  </mat-card-header>
  <!-- Contenido de filtros -->
  <mat-card-content>
    <form [formGroup]="formFilter">
      <div class="row">
        <div class="col-sm-12 col-md-8 col-lg-6" *ngIf="!idExpediente">
          <app-buscar-expediente (eventEntity)="selectExpediente($event)"></app-buscar-expediente>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rango de Fechas</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate placeholder="Desde" [formControl]="formFilter.get('FechaDesde')">
              <input matEndDate placeholder="Hasta" [formControl]="formFilter.get('FechaHasta')">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="col">

          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spEstadosAudiencia" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Estado Audiencia</mat-label>
            <mat-select multiple placeholder="Seleccione opcion" formControlName="IdsEstadoAudiencia">
              <mat-option [value]="estadosAudiencia.id" *ngFor="
                    let estadosAudiencia of estadosAudiencia;
                    let i = index;
                    trackBy: trackByItems
                  ">
                {{ estadosAudiencia.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">

        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Lugar</mat-label>
            <input matInput type="text" formControlName="Lugar" />
          </mat-form-field>
        </div>
        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Sala</mat-label>
            <input matInput type="text" formControlName="Sala" />
          </mat-form-field>
        </div>
        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spTiposAudiencia" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Tipo Audiencia</mat-label>
            <mat-select multiple placeholder="Seleccione opcion" formControlName="IdsTipoAudiencia">
              <mat-option [value]="tipoAudiencia.id" *ngFor="
                    let tipoAudiencia of tiposAudiencia;
                    let i = index;
                    trackBy: trackByItems
                  ">
                {{ tipoAudiencia.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rango de Fechas de Alta</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate placeholder="FechaAltaDesde" [formControl]="formFilter.get('FechaAltaDesde')">
              <input matEndDate placeholder="FechaAltaHasta" [formControl]="formFilter.get('FechaAltaHasta')">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rango de Fechas de Alta</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate placeholder="FechaAltaDesde" [formControl]="formFilter.get('FechaAltaDesde')">
              <input matEndDate placeholder="FechaAltaHasta" [formControl]="formFilter.get('FechaAltaHasta')">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>LinkVirtual</mat-label>
            <input matInput type="text" formControlName="LinkVirtual" />
          </mat-form-field>
        </div>
        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>ActaUrl</mat-label>
            <input matInput type="text" formControlName="ActaUrl" />
          </mat-form-field>
        </div>
        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-checkbox formControlName="Notificado">
            Notificado
          </mat-checkbox>
        </div>
        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-checkbox formControlName="RequiereActa">
            ¿Requiere Acta?
          </mat-checkbox>
        </div>
        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-checkbox formControlName="ActaGenerada">
            ¿Acta Generada?
          </mat-checkbox>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-auto">
          <div style="display: flex; align-items: center; gap: 8px;">
            <app-button-filter-table (click)="aplicarFiltro()"></app-button-filter-table>
            <app-button-filter-table-clear (click)="limpiarFiltro()"></app-button-filter-table-clear>
          </div>
        </div>
        <div class="col-auto">
          <mat-slide-toggle (change)="filtrosAvanzados($event)" color="primary">
            Filtros Avanzados
          </mat-slide-toggle>
        </div>
      </div>
    </form>
  </mat-card-content>

  <mat-card-content>
   <mat-divider></mat-divider>
    <ngx-spinner [zIndex]="100" name="spAudiencia" bdColor="rgba(255,255,255,0.8)" size="default"
      color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>


    <!-- Inicio Contenedor acciones tabla -->
    <div class="contenedor-acciones-tablas">
      <div class="acciones-tabla">
        <!-- Boton de Acciones -->
        <!-- <app-button-action></app-button-action> -->
      </div>
      <mat-form-field appearance="outline" *ngIf="data" class="buscador-tabla">
        <mat-icon matPrefix>search</mat-icon>
        <mat-label>Buscar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" #input />
      </mat-form-field>
    </div>
    <!-- Fin Contenedor acciones tabla -->

    <div *ngIf="data">
      <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" matSort matSortStart="asc">
        <ng-container matColumnDef="lugar">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Lugar</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let audiencia">
            {{ audiencia.lugar }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="sala">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Sala</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let audiencia">
            {{ audiencia.sala }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fecha">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Fecha</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let audiencia">
            {{ audiencia.fecha | date : "short" }}
          </mat-cell>
        </ng-container>



        <ng-container matColumnDef="estadoAudiencia">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Estado Audiencia</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let audiencia">
            {{
            audiencia.estadoAudiencia == undefined
            ? ""
            : (audiencia.estadoAudiencia.descripcion )
            }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="tipoAudiencia">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Tipo Audiencia</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let audiencia">
            {{
            audiencia.tipoAudiencia == undefined
            ? ""
            : (audiencia.tipoAudiencia.descripcion )
            }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="asignadoA">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Asignado A</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let audiencia">
            <app-avatar-iniciales [nombre]='audiencia.asignadoA?.nombre' [apellido]='audiencia.asignadoA?.apellido'
              [activo]='audiencia.asignadoA?.activo'></app-avatar-iniciales>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="estados">
          <mat-header-cell mat-header-cell *matHeaderCellDef><strong>Estados</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let audiencia">
            <mat-icon class="icon-hover" matTooltip="Notificado" *ngIf="audiencia.notificado">notifications</mat-icon>
            <mat-icon class="icon-hover" matTooltip="No notificado" *ngIf="!audiencia.notificado">notifications_off</mat-icon>
            <mat-icon class="icon-hover" matTooltip="Requiere acta" *ngIf="!audiencia.requiereActa">description</mat-icon>
          </mat-cell>
        </ng-container>

        <!-- Accion Column -->
        <ng-container matColumnDef="accion">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            <strong>Acción</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let audiencia" class="action-link">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Ver, entidad: {audiencia} })"
                *appRoles="['Audiencias.Ver']">
                <mat-icon>visibility</mat-icon>
                <span>Ver</span>
              </button>
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Modificar, entidad: {audiencia} })"
                *appRoles="['Audiencias.Modificar']">
                <mat-icon>edit</mat-icon>
                <span>Editar</span>
              </button>
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Eliminar, entidad: {audiencia} })"
                *appRoles="['Audiencias.Eliminar']">
                <mat-icon>delete</mat-icon>
                <span>Eliminar</span>
              </button>
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row matRipple *matRowDef="let row; columns: displayedColumns"></mat-row>
      </table>

      <mat-paginator showFirstLastButtons class="paginator" *ngIf="data" [pageSize]="20"
        [pageSizeOptions]="[5, 10, 20, 50, 100, 200]">
      </mat-paginator>
    </div>
    <app-sin-datos-para-mostrar [dataSource]="dataSource"></app-sin-datos-para-mostrar>
  </mat-card-content>
</mat-card>
